import styles from "./style.module.scss";
import Image1 from "src/assets/photo-gallery/photo14.jpg";
import Image2 from "src/assets/top_image.jpg";
import Image3 from "src/assets/photo-gallery/photo16.jpg";
import Image4 from "src/assets/photo-gallery/photo1.jpg";
import Image5 from "src/assets/photo-gallery/photo17.jpg";
import Image6 from "src/assets/photo-gallery/photo18.jpg";
import Image7 from "src/assets/photo-gallery/photo19.jpg";
import Image8 from "src/assets/photo-gallery/photo20.jpg";
import Image9 from "src/assets/photo-gallery/photo21.jpg";
import Image10 from "src/assets/photo-gallery/photo22.jpg";
import MapImage from "src/assets/map.jpg";
import clsx from "clsx";

export const RoomSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h2>部屋紹介</h2>
        <img src={MapImage} alt="MapImage" className={styles.mapImage} />
      </div>
      <div className={clsx(styles.innerBox, styles.mt60)}>
        <h3>玄関</h3>
        <p>
          高さのある玄関扉で、かつ奥行きも広いため、サーフボードや釣り竿を持って中に入れます。
        </p>
      </div>
      <div className={styles.imageBox}>
        <div className={styles.leftBox}>
          <img src={Image1} alt="Image1" />
        </div>
        <div className={styles.rightBox}>
          <img src={Image2} alt="Image2" className={styles.bottom} />
        </div>
        <div className={styles.grayBox} />
      </div>
      <div className={clsx(styles.innerBox, styles.mt60)}>
        <h3>リビング</h3>
        <p>
          最低限の家具で余白の多いスペースとなっており、のびのびと過ごすことができます。
        </p>
      </div>
      <div className={styles.imageBox}>
        <div className={styles.leftBox}>
          <img src={Image3} alt="Image3" />
        </div>
        <div className={styles.rightBox}>
          <img src={Image4} alt="Image4" />
        </div>
        <div className={styles.grayBox} />
      </div>
      <div className={clsx(styles.innerBox, styles.mt60)}>
        <h3>ダイニングキッチン</h3>
        <p>
          複数人で作業ができる広々としたキッチンで、座っている人との会話しながら調理ができる距離感に食卓があります。
        </p>
      </div>
      <div className={styles.imageBox}>
        <div className={styles.leftBox}>
          <img src={Image5} alt="Image5" />
        </div>
        <div className={styles.rightBox}>
          <img src={Image6} alt="Image6" />
        </div>
        <div className={styles.grayBox} />
      </div>
      <div className={clsx(styles.innerBox, styles.mt60)}>
        <h3>フレキシブルルーム</h3>
        <p>
          軽い運動をしてもよし、ゆったり話してもよし、寝てもよし。あえて用途を決めていない部屋をどう使うかも楽しみの一つ。
        </p>
      </div>
      <div className={styles.imageBox}>
        <div className={styles.leftBox}>
          <img src={Image7} alt="Image7" />
        </div>
        <div className={styles.rightBox}>
          <img src={Image8} alt="Image8" />
        </div>
        <div className={styles.grayBox} />
      </div>
      <div className={clsx(styles.innerBox, styles.mt60)}>
        <h3>浴室、洗﻿面所</h3>
        <p>
          浴室・洗面所・洗濯機が全て2階にあり、1階と2階で全く違う使い方ができるため、それぞれの時間の使い方を邪魔しない作りになっています。
        </p>
      </div>
      <div className={styles.imageBox}>
        <div className={styles.leftBox}>
          <img src={Image9} alt="Image9" />
        </div>
        <div className={styles.rightBox}>
          <img src={Image10} alt="Image10" />
        </div>
        <div className={styles.grayBox} />
      </div>
    </section>
  );
};
